import {rest} from './rest';
import * as selectors from './selectors';
import * as constants from './constants';

export const org = {
    rest,
    selectors,
    constants,
};
